// URL base del backend PHP (sin el "?url=" final).
// En desarrollo local usa localhost/Laragon. En producción se toma de la
// variable de entorno VITE_API_URL definida en frontend/.env.production
// (ej: VITE_API_URL=https://tudominio.com/Tournament/public/index.php)
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/Tournament/public/index.php'
